import { Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { toolbarStyles as styles } from "./toolbar.stylex";

type StoreEditorPublishButtonProps = Readonly<{
  disabled: boolean;
  firstPublish: boolean;
  awaitingReview: boolean;
  publishing: boolean;
  onPublish(): void;
}>;

export function StoreEditorPublishButton({
  disabled,
  firstPublish,
  awaitingReview,
  publishing,
  onPublish,
}: StoreEditorPublishButtonProps) {
  let label = firstPublish ? "Publish — first publish needs review" : "Publish";
  let compactLabel = "Publish";

  if (awaitingReview) {
    label = "Awaiting review";
    compactLabel = "Pending";
  }

  if (publishing) {
    label = "Publishing…";
    compactLabel = "Publishing…";
  }

  return (
    <Button
      size="sm"
      variant="primary"
      aria-label={label}
      disabled={disabled}
      onClick={onPublish}
    >
      <span {...stylex.props(styles.description)}>{label}</span>
      <span {...stylex.props(styles.compactLabel)}>{compactLabel}</span>
    </Button>
  );
}
